<template>
  <div class="mobileAddress botPage">
    <mbHeader :title="$t('address_manage')" :left="true" :lang="true"></mbHeader>
    <addressNew></addressNew>
  </div>
</template>

<script>
import addressNew from "../Profile/addressNew";
import mbHeader from "../../components/mobile/mbHeader";

export default {
  name: "mobileAddress",
  components: {addressNew, mbHeader},
}
</script>

<style scoped lang="less">
.mobileAddress {
  min-height: 100vh;
  padding: 66px 16px 16px;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileAddress.vue